import englishWordUtils from './englishWordsUtils';
import englishStopWords from './englishStopWords';

const exp = {};

function populatedExp() {
  [englishStopWords, englishWordUtils].forEach(module => {
    Object.keys(module).forEach(
      methodName => (exp[methodName] = module[methodName])
    );
  });

  return exp;
}

export default populatedExp;
